import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider, ensureSessionId } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Framework from "@/pages/Framework";
import Assessment from "@/pages/Assessment";
import Mediation from "@/pages/Mediation";
import Toolkit from "@/pages/Toolkit";
import Pilot from "@/pages/Pilot";
import Feedback from "@/pages/Feedback";
import Book from "@/pages/Book";
import About from "@/pages/About";
import Developer from "@/pages/Developer";
import Research from "@/pages/Research";
import Disclaimer from "@/pages/Disclaimer";
import Privacy from "@/pages/Privacy";
import AgreementReadiness from "@/pages/AgreementReadiness";
import JoinNetwork from "@/pages/JoinNetwork";
import Admin from "@/pages/Admin";
import "@/App.css";

function App() {
  useEffect(() => { ensureSessionId(); }, []);
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/framework" element={<Framework />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/mediation" element={<Mediation />} />
            <Route path="/toolkit" element={<Toolkit />} />
            <Route path="/pilot" element={<Pilot />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/book" element={<Book />} />
            <Route path="/about" element={<About />} />
            <Route path="/developer" element={<Developer />} />
            <Route path="/research" element={<Research />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/agreement" element={<AgreementReadiness />} />
            <Route path="/join" element={<JoinNetwork />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Layout>
        <Toaster theme="dark" richColors position="top-right" />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
